/** Normalise UK postcode spacing (e.g. so143tj → SO14 3TJ). */
export function formatUkPostcode(raw: string): string {
  const compact = raw.replace(/\s+/g, "").toUpperCase();
  if (compact.length < 5) return compact;
  return `${compact.slice(0, -3)} ${compact.slice(-3)}`;
}

/** Returns parsed postcode when input is or contains a UK postcode. */
export function extractUkPostcode(input: string): string | null {
  const match = input
    .trim()
    .toUpperCase()
    .match(/\b([A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2})\b/);
  return match ? formatUkPostcode(match[1]) : null;
}

/** True when the field value is only a postcode (optional trailing comma/space). */
export function isUkPostcodeOnly(input: string): boolean {
  const trimmed = input.trim().replace(/[,.]$/, "").trim();
  const postcode = extractUkPostcode(trimmed);
  if (!postcode) return false;
  const without = trimmed.toUpperCase().replace(postcode, "").trim();
  return without.length === 0;
}
